import { styled } from "@vitality-ds/system";
import baseDividerStyles from "./styles/BaseDivider.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseDivider = styled("hr", baseDividerStyles);